import * as React from 'react';
const SvgNotFound = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={120}
    height={121}
    fill="none"
    viewBox="0 0 120 121"
    {...props}
  >
    <circle cx={60} cy={60.5} r={60} fill="#E0EBFF" />
    <path
      fill="#0A2FFF"
      d="M106.985 45.272c.332-1.234 2.159-1.234 2.492 0l.174.646c.121.448.492.794.963.896l.363.078a1.224 1.224 0 0 1 0 2.408l-.363.079a1.26 1.26 0 0 0-.963.895l-.174.647c-.333 1.234-2.16 1.234-2.492 0l-.175-.647a1.26 1.26 0 0 0-.963-.895l-.362-.079a1.224 1.224 0 0 1 0-2.408l.362-.078c.471-.102.843-.448.963-.896z"
    />
    <circle cx={16.846} cy={68.75} r={3} fill="#C2D4FF" />
    <circle cx={13.096} cy={59.75} r={1.5} fill="#C2D4FF" />
    <circle cx={60} cy={110.75} r={2.25} fill="#C2D4FF" />
    <path
      fill="#85A3FF"
      d="M64.246 8.868c-.333-1.234-2.16-1.234-2.492 0l-.174.647c-.121.447-.493.793-.963.895l-.363.078a1.224 1.224 0 0 0 0 2.409l.363.078c.47.102.842.447.963.895l.174.647c.332 1.234 2.16 1.234 2.492 0l.174-.647c.12-.448.493-.793.963-.895l.363-.079a1.224 1.224 0 0 0 0-2.408l-.363-.078a1.26 1.26 0 0 1-.963-.895z"
    />
    <circle
      cx={1.5}
      cy={1.5}
      r={1.5}
      fill="#0A2FFF"
      transform="matrix(-1 0 0 1 56.25 15.73)"
    />
    <rect width={51} height={60} x={27.75} y={41} fill="#85A3FF" rx={6} />
    <g filter="url(#a)" opacity={0.5}>
      <path
        fill="#0014CC"
        d="M49.5 86h39a6 6 0 0 0 6-6V45.472a6 6 0 0 0-1.986-4.46L84.21 33.54A6 6 0 0 0 80.198 32H49.5a6 6 0 0 0-6 6v42a6 6 0 0 0 6 6"
      />
    </g>
    <path
      fill="#fff"
      d="M49.5 86h39a6 6 0 0 0 6-6V38l-12-12h-33a6 6 0 0 0-6 6v48a6 6 0 0 0 6 6"
    />
    <path fill="#85A3FF" d="M82.5 38h12l-12-12z" />
    <foreignObject width={84.242} height={84.241} x={10.167} y={9.167}>
      <div
        xmlns="http://www.w3.org/1999/xhtml"
        style={{
          backdropFilter: 'blur(7.67px)',
          clipPath: 'url(#b)',
          height: '100%',
          width: '100%',
        }}
      />
    </foreignObject>
    <path
      fill="#fff"
      fillOpacity={0.4}
      d="M52.287 78.075c14.795 0 26.788-11.993 26.788-26.788S67.082 24.5 52.287 24.5 25.5 36.493 25.5 51.287c0 14.795 11.993 26.788 26.787 26.788"
      data-figma-bg-blur-radius={15.333}
    />
    <path
      fill="#0014CC"
      d="m62.57 44.252-3.247-3.247-7.036 7.035-7.035-7.035-3.247 3.247 7.035 7.035-7.035 7.036 3.247 3.247 7.035-7.035 7.036 7.035 3.247-3.247-7.035-7.036z"
    />
    <path
      fill="#0014CC"
      fillRule="evenodd"
      d="M68.331 72.743C57.84 80.61 42.888 79.771 33.346 70.23c-10.461-10.461-10.461-27.422 0-37.883s27.422-10.461 37.883 0c9.542 9.542 10.38 24.493 2.514 34.985L94.5 88.088 89.088 93.5zm-.35-5.761c-8.667 8.668-22.72 8.668-31.388 0s-8.668-22.721 0-31.389 22.721-8.668 31.389 0 8.668 22.721 0 31.389"
      clipRule="evenodd"
    />
    <defs>
      <clipPath id="b" transform="translate(-10.167 -9.167)">
        <path d="M52.287 78.075c14.795 0 26.788-11.993 26.788-26.788S67.082 24.5 52.287 24.5 25.5 36.493 25.5 51.287c0 14.795 11.993 26.788 26.787 26.788" />
      </clipPath>
      <filter
        id="a"
        width={77}
        height={80}
        x={30.5}
        y={19}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feGaussianBlur
          result="effect1_foregroundBlur_1099_1315"
          stdDeviation={6.5}
        />
      </filter>
    </defs>
  </svg>
);
export default SvgNotFound;
